import { gql } from '@apollo/client';
import { daySequenceFragment } from '../daySequence/daySequence.gql';

export const GET_TIMESHEETS_FOR_APPROVAL = gql`
  ${daySequenceFragment}
  query GetTimesheetsForApproval(
    $tenantId: String!
    $clientId: String
    $view: TimesheetApprovalView!
    $limit: Int
    $lastEvaluatedKey: String
  ) {
    getTimesheetsForApproval(
      tenantId: $tenantId
      clientId: $clientId
      view: $view
      limit: $limit
      lastEvaluatedKey: $lastEvaluatedKey
    ) {
      items {
        daySequence {
          ...DaySequenceFragment
        }
        workerName
        workerProfileImageUrl
        jobTitle
        jobTimezone
        workType
        siteId
        siteName
        clientId
        clientName
      }
      hasMore
      lastEvaluatedKey
    }
  }
`;
